<template>
  <div class="main">
    <!-- BOTÕES -->
    <div class="d-flex flex-column">
      <label class="mb-0">{{ $t('selecione-um-tipo-de-mapeamento') }}</label>
      <b-button-group class="m-2">
        <b-button 
          @click="select(0)" 
          :class="{'btn-success': buttonSelected.current }">
          {{$t('currents')}}
        </b-button>
        <b-button 
          @click="select(1)" 
          :class="{'btn-success': buttonSelected.operation }">
          {{$t('operations')}}
        </b-button>
        <b-button 
          @click="select(2)" 
          :class="{'btn-success': buttonSelected.internalCurrent }">
          {{ $t('corrente-interna') }}
        </b-button>
      </b-button-group>
    </div>
      <!-- /BOTÕES -->

      <!-- CORRENTE -->
      <div v-if="buttonSelected.current" class="selectable pt-1">
        <select 
          id="select-current" 
          class="form-control" 
          @change="changeCurrent()" 
          v-model="form.current"> 
            <option :value="null" disabled >{{ $t('escolha-uma-corrente') }}</option>
            <option v-for="(current, index) in currents"
              :key="`node-current-${index}`" :value="current">
                {{current}}
            </option>
        </select>

        <div v-if="form.current" class="pt-1">
          <select 
            id="select-properties" 
            class="form-control" 
            @change="changeCurrentProperties()" 
            v-model="form.prop">
              <option :value="null" disabled>{{ $t('escolha-uma-propriedade') }}</option>
              <option v-for="(prop, index) in currentProperties"
                :key="`node-prop-${index}`" :value="prop">
                  {{ prop.name }}
              </option>
          </select> 
        </div>
      </div>
      <!--/CORRENTE -->

      <!-- OPERATIONS -->
      <div v-if="buttonSelected.operation" class="selectable pt-1 ">
        <select class="form-control" id="select-operation" @change="changeOperation()" v-model="form.operation"> 
            <option :value="null" disabled>{{ $t('escolha-uma-operacao') }}</option>
            <option v-for="(operation, index) in operations"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /OPERATIONS -->

      <!-- OPERAÇÕES FERMENTACAO -->
      <div v-if="buttonSelected.internalCurrent" class="selectable pt-1">
        <select class="form-control" id="select-operation" @change="changeFermentation()" v-model="form.fermentation"> 
            <option :value="null" disabled>{{ $t('escolha-uma-fermentacao') }}</option>
            <option v-for="(operation, index) in fermentations"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /OPERAÇÕES FERMENTACAO -->

      <!-- COMPONENTE FERMENTACAO -->
      <div v-if="form.fermentation" class="selectable pt-1">
        <select class="form-control" id="select-operation" @change="changeFermentationComponent()" v-model="form.fermentationComponent"> 
            <option :value="null" disabled>{{ $t('escolha-uma-componente') }}</option>
            <option v-for="(operation, index) in componentsFermentation"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /COMPONENTE FERMENTACAO -->

      <!-- COMPONENTE INTERNA FERMENTACAO -->
      <div v-if="form.fermentationComponent" class="selectable pt-1">
        <select class="form-control" id="select-operation" @change="changeFermentationInnerComponent()" v-model="form.fermentationComponentType"> 
            <option :value="null" disabled>{{ $t('escolha-uma-componente-interna') }}</option>
            <option v-for="(operation, index) in componentsFermentationTypes"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /COMPONENTE INTERNA FERMENTACAO -->

      <!-- ATRIBUTO COMPONENTE INTERNA FERMENTACAO -->
      <div v-if="form.fermentationComponentType && form.fermentationComponentType != 'Atributos'" class="selectable pt-1">
        <select class="form-control" id="select-operation" @change="changeComponentsInternalFermentationTypes()" v-model="form.componentsInternalFermentationType"> 
            <option :value="null" disabled>{{ $t('escolha-uma-componente-interna-0') }}</option>
            <option v-for="(operation, index) in componentsInternalFermentationTypes"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /ATRIBUTO COMPONENTE INTERNA FERMENTACAO -->

      <!-- OPÇÃO ATRIBUTO OU EQUIPAMENTO -->
      <div 
        v-if="form.operation && this.attrsOperation" 
        class="selectable pt-1 node-attr">
        <b-form-select 
          id="select-attr" 
          class="form-control input-pentagro" 
          @change="changeOperationEquipment()"
          v-model="form.operationOrEquipment"> 
            <b-form-select-option :value="null" disabled>{{ $t('escolha-atribributo-ou-equipamento') }}</b-form-select-option>
            <b-form-select-option v-for="(value, index) in attrsOperation"
              :key="`node-attr-${index}`" :value="value">
                {{`${value}`}}
            </b-form-select-option>
        </b-form-select>
      </div>
      <!-- /OPÇÃO ATRIBUTO OU EQUIPAMENTO -->

      <!-- ATRIBUTOS -->
      <div 
        v-if="form.prop || (form.operation && !this.attrsOperation) || form.operationOrEquipment || form.fermentationComponentType == 'Atributos' || form.componentsInternalFermentationType" 
        class="selectable pt-1 node-attr">
        <b-form-select 
          id="select-attr" 
          class="form-control input-pentagro" 
          v-model="attrSelected"> 
            <b-form-select-option :value="null" disabled>{{ $t('escolha-um-atributo') }}</b-form-select-option>
            <b-form-select-option v-for="([key, value], index) in attrsMap.entries()"
              :key="`node-attr-${index}`" :value="key">
                {{`${value.key}: ${formatNumber(value.value)}`}}
            </b-form-select-option>
        </b-form-select>
      </div>
      <!-- /ATRIBUTOS -->
  </div>
</template>

<script>
import { NumberFormat } from "../../utils/tools"
import { SingletonEnginnering } from '../../nodes/_service/singletonEngineering'

  export default {
    name:"SelectOperation",
    props: ["node"],
    data() {
      return {
        currents: SingletonEnginnering.currents,
        operations: SingletonEnginnering.operations,
        fermentations: SingletonEnginnering.operations.filter(t => t.match(/Fermentacao/)),
        buttonSelected: { current: false, operation: false, internalCurrent: false },
        form: { 
          current: null, 
          prop: null, 
          operation: null,
          operationOrEquipment: null,
          fermentation: null,
          fermentationComponent: null,
          fermentationComponentType: null,
          componentsInternalFermentationType: null
        },
        componentsFermentation: null,
        componentsFermentationTypes: null,
        componentsInternalFermentationTypes: null,
        attrsSelect: null,
        attrSelected: null,
        attrsMap: null,
        attrsOperation: null,
        currentProperties: "",
        formatNumber: NumberFormat,
        chagedButton: 1,
      }
    },

    watch: {
      attrSelected(value){
        this.$emit("checkChanges", value)
        if(!value) return
          let prop = this.attrsMap.get(value)
          if(prop)
            this.$emit("propSelected", [prop]);
      },
        
      'form.operation'(value) {
        this.$emit("checkChangesOP", value)
        this.$emit("receiveAttrs", this.attrsMap)
        if(!this.attrSelected) return
          let prop = this.attrsMap.get(this.attrSelected)
          if(prop)
            this.$emit("propSelected", [prop]);
      },

      'form.current'(value) {
        this.$emit("checkChangesCt", value)
        if(!this.attrSelected) return
          let prop = this.attrsMap.get(this.attrSelected)
          if(prop)
            this.$emit("propSelected", [prop]);
          
          this.$emit("SelectedCurrent", this.form.current);
          this.$emit("currentSelected", this.form.current);
      }
    },

    methods: {
      loadNode(){
        console.log('Carregando\nthis.node :>> ', this.node);

        if(!this.node.dataType || !this.node.data.length)
          return
          
        if(this.node.dataType == 'Operações'){
          this.buttonSelected.operation = true;
          this.form.operation = this.node.data[0].index
          this.changeOperation();
          this.form.operationOrEquipment = this.node.data[0].equipName ? this.node.data[0].equipName : '--Atributos--'
          this.attrsMap.set(this.node.data[0].key, this.node.data[0])
          this.attrSelected = this.node.data[0].key
        }
        else if(this.node.dataType == "Correntes")
        {
          this.buttonSelected.current = true;
          this.form.current = this.node.data[0].index
          this.changeCurrent()
          this.form.prop = {index: this.node.data[0].propIndex, name: this.node.data[0].propName}
          this.changeCurrentProperties()
          this.attrsMap.set(this.node.data[0].key, this.node.data[0])
          this.attrSelected = this.node.data[0].key
          this.$emit("currentSelected", this.form.current);
        }
        else if(this.node.dataType == "CorrenteInterna"){
          this.buttonSelected.internalCurrent = true;
          this.form.fermentation = this.node.data[0].index
          this.changeFermentation()
          this.form.fermentationComponent = this.node.data[0].component
          this.changeFermentationComponent()

          if(this.node.data[0].subType == "Atributos")
          {
            this.form.fermentationComponentType = this.node.data[0].subType
            this.changeFermentationInnerComponent()
            this.attrsMap.set(this.node.data[0].key, this.node.data[0])
            this.attrSelected = this.node.data[0].key
          }
          else
          {
            this.form.fermentationComponentType = "Componentes"
            this.changeFermentationInnerComponent()
            this.form.componentsInternalFermentationType = this.node.data[0].subType
            this.changeComponentsInternalFermentationTypes()
            this.attrsMap.set(this.node.data[0].key, this.node.data[0])
            this.attrSelected = this.node.data[0].key
          }
        }
      },

      select(index){
        Object.keys(this.buttonSelected).forEach((show, i) => { this.buttonSelected[show] = i == index })
        this.form.current = null
        this.form.operation = null
        this.form.prop = null
        this.attrSelected = null
        this.form.fermentation = null
        this.form.operationOrEquipment = null
        this.form.fermentationComponent = null
        this.form.fermentationComponentType = null
        this.form.componentsInternalFermentationType = null
        this.$emit("currentSelected", '');

        if(index == 0)
          this.$emit("typeSelected", "Correntes");
        if(index == 1)
          this.$emit("typeSelected", "Operações");
        if(index == 2)
          this.$emit("typeSelected", "CorrenteInterna");

        this.$emit("changedButton", ++this.chagedButton);
      },

      changeCurrent(){
        let props = SingletonEnginnering.getCurrentProperties(this.form.current);
        this.currentProperties = props
        this.form.prop = null
        this.attrSelected = props;
        this.attrsMap = new Map();
        props.forEach(e => this.attrsMap.set(e.key, e))
      },

      changeOperation(){
        this.form.prop = null
        this.form.operationOrEquipment = null
        this.attrsOperation = null
        this.changeOperationWithEquipment()
        this.loadAttrOperation()
      },

      changeOperationWithEquipment(){
        let equipments = SingletonEnginnering.getEquipamentsProperties(this.form.operation)
        this.attrsOperation = Object.keys(equipments)
        this.attrsOperation.unshift("--Atributos--")
      },

      changeOperationEquipment(){
        this.attrSelected = null
        let equipments = SingletonEnginnering.getEquipamentsProperties(this.form.operation)
        if(equipments && this.form.operationOrEquipment != "--Atributos--"){
          this.attrsSelect = equipments[this.form.operationOrEquipment]
          this.attrsMap = new Map()
          this.attrsSelect.forEach(e => this.attrsMap.set(e.key, e))
        }
        else
          this.loadAttrOperation()
      },

      loadAttrOperation(){
        let attrs = SingletonEnginnering.getOperationsProperties(this.form.operation);
        this.attrsSelect = attrs
        this.attrsMap = new Map()
        attrs.forEach(e => this.attrsMap.set(e.key, e))
      },

      changeFermentation(){
        let typeComponents = SingletonEnginnering.getInnerCurrentOfTheOperation(this.form.fermentation);
        this.componentsFermentation = typeComponents
      },

      changeFermentationComponent(){
        let typesComponent = SingletonEnginnering.getInnerCurrentOfComponents(this.form.fermentation, this.form.fermentationComponent);
        this.componentsFermentationTypes = typesComponent
        this.form.fermentationComponentType = null
        this.attrSelected = null
      },

      changeFermentationInnerComponent(){
        let propsOfTypesComponent
        this.form.componentsInternalFermentationType = null
        this.attrSelected = null

        if(this.form.fermentationComponentType == "Atributos"){
          propsOfTypesComponent = SingletonEnginnering.getAttributesPropertiesFromAnInnerCurrent(this.form.fermentation, this.form.fermentationComponent)
          this.attrsMap = new Map()
          propsOfTypesComponent.forEach(e => this.attrsMap.set(e.key, e))
          return
        }
        else
          this.componentsInternalFermentationTypes = SingletonEnginnering.getComponentPropertiesFromAnInnerCurrentStrings(this.form.fermentation, this.form.fermentationComponent, this.form.fermentationComponentType);

      },

      changeComponentsInternalFermentationTypes(){
          let propsOfTypesComponent = SingletonEnginnering.getComponentPropertiesFromAnInnerCurrent(this.form.fermentation, this.form.fermentationComponent, this.form.componentsInternalFermentationType)
          this.attrsMap = new Map()
          this.attrSelected = null
          propsOfTypesComponent.forEach(e => this.attrsMap.set(e.key, e))
          return
      },

      changeCurrentProperties(){
        let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.form.current, this.form.prop);
        this.attrsSelect = attrs;
        this.attrSelected = null
        this.attrsMap = new Map()
        attrs.forEach(e => this.attrsMap.set(e.key, e))
      },
    },

    mounted(){
      this.loadNode()
    }
}
</script>

<style scoped>
.main {
  width: 100%;
}
.main  .selectable {
  padding: 8px;
}

</style>